import withEditarUsuarioSesion from "../../hoc/Docentes/withEditarUsuarioSesion";
import EditarNombreUsuario from "../../view/components/RegistroUsuarios/DatosSesion/EditarDatosSesion/EditarNombreUsuario";

export default withEditarUsuarioSesion(EditarNombreUsuario);